import { useState } from 'react';

import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

interface ISearchV2 {
  onSearch: (value: string) => void;
  defaultSearch?: string;
  value?: string;
}

export const SearchV2 = ({ defaultSearch = '', value, onSearch }: ISearchV2) => {
  const [inputSearch, setInputSearch] = useState(defaultSearch);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchValue: string = event.target.value;
    setInputSearch(newSearchValue);
    onSearch(newSearchValue);
  };

  return (
    <InputGroup size="sm" width="8rem" ml="auto" mr="2">
      <InputLeftElement pointerEvents="none" children={<FontAwesomeIcon icon={faSearch} />} />
      <Input type="search" placeholder="Search" value={value ?? inputSearch} onChange={onChange} />
    </InputGroup>
  );
};
